import React, { useContext, useEffect, useMemo } from 'react';
import { Snackbar } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';

import { SnackMessageContext, ISnack } from '../../contexts/snackMessage/SnackMessageContext';
import { stylesConstants } from '../../styles/stylesConstants';
import { config } from '../../constants/config';

interface ISnackProp extends ISnack {
  pop: (id: string) => void;
  index: number;
}

const Snack: React.FC<ISnackProp> = ({ severity, message, title, id, pop, index }) => {
  useEffect(() => {
    let timer = setTimeout(() => pop(id), config.snackDuration);
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [id, pop]);

  const position = useMemo(
    () => stylesConstants.snack.bottom + index * stylesConstants.snack.position,
    [index],
  );

  return (
    <Snackbar open={true} key={id} style={{ bottom: position }}>
      <Alert
        severity={severity}
        onClose={() => {
          pop(id);
        }}
        variant="filled"
      >
        {title && <AlertTitle>{title}</AlertTitle>}
        {message}
      </Alert>
    </Snackbar>
  );
};

const SnackMessage: React.FC = () => {
  const { snacks, pop } = useContext(SnackMessageContext);

  return (
    <>
      {snacks.map((snack, index) => (
        <Snack {...snack} pop={pop} key={snack.id} index={index} />
      ))}
    </>
  );
};

export default SnackMessage;
